import i18n from "../../../i18n";

const ActualPricesLotGridPluginSettings = (): IPluginSettings => {
    const t = (value: string) => i18n.t("sidePanel." + value);
    return {
        name: t("accounting.submenu.actualPrices"),
        mnemocode: 'actual_prices_lot_plugin',
        permission: 'Lot',
        columns: [
            {
                order: 0,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'IdGlobal',
                visibility: false,
                width: 150
            },
            {
                order: 1,
                propertyName: 'goodsName',
                propertyType: 'string',
                displayName: 'Номенклатура',
                visibility: true,
                width: 150
            },
            {
                order: 2,
                propertyName: 'producerName',
                propertyType: 'string',
                displayName: 'Производитель',
                visibility: true,
                width: 150
            },
            {
                order: 3,
                propertyName: 'supplier',
                propertyType: 'string',
                displayName: 'Поставщик',
                visibility: true,
                width: 150
            },
            {
                order: 4,
                propertyName: 'seriesBestBefore',
                propertyType: 'date',
                displayName: 'Срок годности',
                visibility: true,
                width: 150
            },
            {
                order: 5,
                propertyName: 'internalBarcode',
                propertyType: 'string',
                displayName: 'Штрихкод',
                visibility: true,
                width: 150
            },
            {
                order: 6,
                propertyName: 'dateDocument',
                propertyType: 'datetime',
                displayName: 'Дата поставки',
                visibility: true,
                width: 150
            },
            {
                order: 7,
                propertyName: 'quantityRem',
                propertyType: 'decimal',
                displayName: 'Количество на остатке, шт.',
                visibility: true,
                width: 150
            },
            {
                order: 8,
                propertyName: 'sales',
                propertyType: 'decimal',
                displayName: 'Количество продаж, шт.',
                visibility: true,
                width: 150
            },
            {
                order: 9,
                propertyName: 'averageSales',
                propertyType: 'decimal',
                displayName: 'Среднее количество продаж, шт.',
                visibility: true,
                width: 150
            },
            {
                order: 10,
                propertyName: 'retailPriceIncVat',
                propertyType: 'decimal',
                displayName: 'Розничная цена с НДС, руб.',
                visibility: true,
                width: 150
            },
            {
                order: 11,
                propertyName: 'supplierPriceIncVat',
                propertyType: 'decimal',
                displayName: 'Цена поставщика с НДС, руб.',
                visibility: true,
                width: 150
            },
            {
                order: 12,
                propertyName: 'adprice',
                propertyType: 'decimal',
                displayName: 'Наценка, %',
                visibility: true,
                width: 150
            },
            {
                order: 13,
                propertyName: 'actualPrice',
                propertyType: 'decimal',
                displayName: 'Актуальная цена поставщика, руб.',
                visibility: true,
                width: 150
            },
            {
                order: 14,
                propertyName: 'differencePercent',
                propertyType: 'decimal',
                displayName: 'Упущенная прибыль, %',
                visibility: true,
                width: 150
            },
            {
                order: 15,
                propertyName: 'differenceRUB',
                propertyType: 'decimal',
                displayName: 'Упущенная прибыль, руб.',
                visibility: true,
                width: 150
            },
            {
                order: 16,
                propertyName: 'priceRevaluation',
                propertyType: 'decimal',
                displayName: 'Цена для переоценки, руб.',
                visibility: true,
                width: 150
            },
            {
                order: 17,
                propertyName: 'finalAdprice',
                propertyType: 'decimal',
                displayName: 'Итоговая наценка, %',
                visibility: true,
                width: 150
            },
            {
                order: 18,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 150
            },
            {
                order: 19,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаление',
                visibility: true,
                width: 150
            },
            {
                order: 20,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: true,
                width: 150
            },
            {
                order: 21,
                propertyName: 'goodsCode',
                propertyType: 'string',
                displayName: 'Код товара',
                visibility: true,
                width: 150
            },{
                order: 22,
                propertyName: 'percentBestBefore',
                propertyType: 'number',
                displayName: 'Срок годности, %',
                visibility: true,
                width: 150
            },
            {
                order: 23,
                propertyName: 'isGnvls',
                propertyType: 'boolean',
                displayName: 'Признак ЖНВЛП',
                visibility: true,
                width: 150
            },
            {
                order: 24,
                propertyName: 'scalingRatioDisplayName',
                propertyType: 'string',
                displayName: 'Упаковка',
                visibility: true,
                width: 150
            },
            {
                order: 25,
                propertyName: 'quantityRes',
                propertyType: 'number',
                displayName: 'Кол-во (Зарезервировано)',
                visibility: true,
                width: 150
            },

        ]
    }
}
export default ActualPricesLotGridPluginSettings